function toggleMessageAccordion() {
  document.addEventListener("click", (e) => {
    const toggle = e.target.closest(".jsMessageAccordionToggle");
    if (!toggle) return;

    toggle.classList.toggle("isOpen");
    const content = toggle.parentElement.querySelector(
      ".jsMessageAccordionContent"
    );
    if (!content) return;

    if (content.style.display === "none") {
      content.style.display = "";
      content.style.overflow = "hidden";
      content.style.height = "0";
      requestAnimationFrame(() => {
        content.style.transition = "height 200ms ease";
        content.style.height = `${content.scrollHeight}px`;
      });
      content.addEventListener("transitionend", function handler() {
        content.removeAttribute("style");
        content.removeEventListener("transitionend", handler);
      });
    } else {
      content.style.overflow = "hidden";
      content.style.height = `${content.scrollHeight}px`;
      requestAnimationFrame(() => {
        content.style.transition = "height 200ms ease";
        content.style.height = "0";
      });
      content.addEventListener("transitionend", function handler() {
        content.style.cssText = "display: none;";
        content.removeEventListener("transitionend", handler);
      });
    }
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default toggleMessageAccordion;